<template>
  <div class="grid-container full">
    <div class="grid-x readyBox">
      <div class=" small-12 cell text-center page-contents-15">
        <p class="top">We have contextualised over</p>
        <h2>{{ numberOfCandidates }}</h2>
        <p class="bottom">candidates, and built one of the largest data sets of the social mobility status of top students in the UK</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RareCandidatesContexulised',
  props: {
    numberOfCandidates: {
      type: String,
    },
  },
};
</script>

<style lang="scss" scoped>

  @import "~@/css/global.scss";

  .full {
    background-color: $mid-grey-background;
  }

  h2
  {
    color: $green-highlight;
    font-weight: bold;
    font-style: normal;
    font-stretch: normal;
    text-align: center;
  }

  p {
    color: #ffffff;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    text-transform: uppercase;
  }

  @media only screen and (max-width: 640px)  {

    h2 {
      font-size: 64px;
      line-height: 1;
      letter-spacing: normal;
      margin: 20px 0 20px 0;
    }

    p {
      font-size: 14px;
      line-height: 1.71;
      letter-spacing: 2px;
      margin: 20px 0 20px 0;
    }
    .top {
      margin-top: 43px;
    }

    .bottom {
      margin-bottom: 43px;
    }
  }

  @media only screen and (min-width: 641px) {

    h2 {
      font-size: 64px;
      line-height: 1;
      letter-spacing: normal;
      margin: 10px 0 10px 0;
    }

    p {
      font-size: 18px;
      line-height: 1.78;
      letter-spacing: 2px;
      margin: 20px 0 20px 0;
    }

    .top {
      margin-top: 75px;
    }

    .bottom {
      margin-bottom: 75px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/candidates/components/RareCandidatesContexulised.vue